import iziAddToCart from "./iziAddToCart";
import iziCanBeBound from "./iziCanBeBound";
import getCookie from "./helpers/getCookie";
import {getTrackingIdsFromLocalStorage} from "./setupAnalytics";
import installMagnificFocusTrapFix from "./integration/mfp/magnificFocusTrapFix";
installMagnificFocusTrapFix();

let lastClickedElement = null;
document.addEventListener("click", function (event) {
  lastClickedElement = event.target;
});

export default async function unboundWidgetClicked(productId) {
  if (lastClickedElement && lastClickedElement.closest("#inpostpay-widget-popup")) {
    return;
  }

  // PRODUCT FLOW (productId truthy)
  if (productId) {
    return await handleProductClick(productId);
  }

  // NON-PRODUCT FLOW (cart/checkout/minicart/order)
  return await handleContextualClick();
}

async function handleProductClick(productId) {
  const widgetPlaceholder = document.querySelector(`.izi-widget-product[data-product-id="${productId}"]`);
  let alertMessage = widgetPlaceholder?.getAttribute("data-alert-message");

  if (!alertMessage) {
    const iziButton = document.querySelector(`inpost-izi-button`);
    alertMessage = iziButton?.getAttribute("data-alert-message") || "An unknown error occurred.";
  }

  try {
    const canBeBound = await iziCanBeBound(productId);
    if (!canBeBound) {
      alert(alertMessage);
      throw new Error("UNDELIVERABLE_PRODUCT");
    }

    const basket_binding_api_key = await iziAddToCart(productId);
    return basket_binding_api_key;
  } catch (error) {
    throw error;
  }
}

async function handleContextualClick() {
  const existingKey = getCookie('basket_binding_api_key') ||
                      IPPWidgetOptions?.basketBindingApiKey;

  if (existingKey && existingKey.trim() !== "" && existingKey !== "undefined") {
    return existingKey;
  }

  const data = new FormData();

  Object.entries(getTrackingIdsFromLocalStorage(false)).forEach(([key, value]) => {
    if (value) {
      data.append(`inpostpay_${key}`, value);
    }
  });

  // Add CSRF nonce for inpost_pay_binding endpoint
  if (window.inpostPayNonces && window.inpostPayNonces.payBinding) {
    data.append("_ajax_nonce", window.inpostPayNonces.payBinding);
  }

  // 2. Bootstrap key via inpost_pay_binding endpoint
  try {
    const response = await fetch(InpostIziJavsscriptWoocommerce.inpost_pay_binding, {
      method: 'POST',
      body: data
    });

    if (!response.ok) {
      console.warn('[InPostPay] Contextual bootstrap failed:', response.status);
      throw new Error('Failed to obtain basket_binding_api_key');
    }

    const responseData = await response.json();
    let basketBindingApiKey = null;

    // Defensive parsing (3 formats)
    if (responseData.basket_binding_api_key) {
      basketBindingApiKey = responseData.basket_binding_api_key;
    } else if (responseData.data && responseData.data.basket_binding_api_key) {
      basketBindingApiKey = responseData.data.basket_binding_api_key;
    } else if (typeof responseData === 'string') {
      basketBindingApiKey = responseData;
    }

    if (basketBindingApiKey && typeof basketBindingApiKey === 'string') {
      IPPWidgetOptions.basketBindingApiKey = basketBindingApiKey;
      // setCookie('basket_binding_api_key', basketBindingApiKey, 3600 * 24);

      return basketBindingApiKey;
    }

    console.warn('[InPostPay] Contextual bootstrap: no key in response');
    throw new Error('No basket_binding_api_key in response');
  } catch (error) {
    console.error('[InPostPay] Contextual bootstrap error:', error);
    throw error;
  }
}
